import React from "react"
import { Trans, useTranslation } from "react-i18next"

function BannerAboutUs() {
  useTranslation()
  return (
    <div className="uk-padding uk-flex uk-flex-center uk-flex-middle uk-height-1-1">
      <div className="uk-text-bold font-white" style={{ fontSize: 80 }}>
        <Trans
          i18nKey="aboutus.jumbotronTitle"
          components={{ red: <span className="font-red" /> }}
        />
      </div>
    </div>
  )
}

export default BannerAboutUs
